var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('primary-button',{attrs:{"title":"このレッスンを予約","css_class":_vm.css_class},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('PlusIcon')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }